<section fxLayoutAlign="end center" style="margin-top: 32px; margin-right: 32px">
  <sbnb-close [border]="true" (click)="redirectToLocksPage()"></sbnb-close>
</section>

<section fxFlexFill fxLayout fxLayoutAlign="center center">
  <div class="fs-dialog-contents" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="24px">
    <div fxLayout="column" fxLayoutGap="24px">
      <h2 *ngIf="locksFound != false || hasUpdatedConnections == true">Connection successful</h2>
      <h2 *ngIf="locksFound == false && hasUpdatedConnections == false">Account connected - no locks found</h2>

      <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px" *ngIf="locksFound != false">
        <span class="domain__text">
          Congratulations your {{ integration }} account has been connected successfully.
        </span>
      </div>

      <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px" *ngIf="loading === true">
        <span class="domain__text">Please wait while we fetch all supported locks from your account.</span>
      </div>

      <div
        fxLayout
        fxLayoutAlign="start start"
        fxLayoutGap="12px"
        *ngIf="locksFound == false && hasUpdatedConnections == false">
        <span class="domain__text">
          Your {{ integration }} account is now connected successfully, but we couldn’t find any locks we're currently
          supporting. If you have locks, hit Retry and we’ll try to fetch them again now.
        </span>
      </div>

      <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px" *ngIf="locksFound == false">
        <span class="domain__text">
          If you add locks in the future, they’ll show up automatically, ready to be linked to your Hospitable.com
          properties.
        </span>
      </div>

      <div fxLayoutAlign="end center" fxLayoutGap="8px">
        <sbnb-button
          label="Continue"
          [loading]="loading"
          (clicked)="matchLocks()"
          *ngIf="locksFound != false"></sbnb-button>

        <sbnb-button
          label="Finish"
          [loading]="loading"
          (clicked)="redirectToLocksPage()"
          *ngIf="locksFound == false && hasUpdatedConnections === true"></sbnb-button>

        <sbnb-button
          label="Retry"
          (clicked)="retryFetchingAllLocks()"
          *ngIf="locksFound == false && hasUpdatedConnections === false"></sbnb-button>
      </div>
    </div>
  </div>
</section>
